/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculate the molar mass of any chemical formula, with a per-element mass breakdown.`)
};

const es_mw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcula la masa molar de cualquier fórmula química, con un desglose de masa por elemento.`)
};

const de_mw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechnen Sie die molare Masse jeder chemischen Formel, mit einer Massenaufschlüsselung pro Element.`)
};

const nl_mw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereken de molaire massa van elke chemische formule, met een massaverdeling per element.`)
};

const fr_mw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculez la masse molaire de n'importe quelle formule chimique, avec une répartition de la masse par élément.`)
};

const it_mw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcola la massa molare di qualsiasi formula chimica, con una scomposizione della massa per elemento.`)
};

const pt_br2_mw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule a massa molar de qualquer fórmula química, com detalhamento de massa por elemento.`)
};

const pt_mw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule a massa molar de qualquer fórmula química, com discriminação da massa por elemento.`)
};

const ja_mw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`任意の化学式のモル質量を、元素ごとの質量内訳付きで計算します。`)
};

const zh_mw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`计算任意化学式的摩尔质量，并给出各元素质量分解。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mw_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mw_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mw_tool_description", locale)
	if (locale === "en") return en_mw_tool_description(inputs)
	if (locale === "es") return es_mw_tool_description(inputs)
	if (locale === "de") return de_mw_tool_description(inputs)
	if (locale === "nl") return nl_mw_tool_description(inputs)
	if (locale === "fr") return fr_mw_tool_description(inputs)
	if (locale === "it") return it_mw_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_mw_tool_description(inputs)
	if (locale === "pt") return pt_mw_tool_description(inputs)
	if (locale === "ja") return ja_mw_tool_description(inputs)
	return zh_mw_tool_description(inputs)
};